var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionDialog',_vm._g(_vm._b({attrs:{"colorBtnAction":"error","label":"Вы действительно хотите удалить этот аналог ?","labelBtnClose":"ОТМЕНА","labelBtnAction":"УДАЛИТЬ"}},'ActionDialog',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }